export function filterByDateRange<T extends DateFilterTransaction>(
    transactions: T[],
    dateFrom: string,
    dateTo: string
): T[] {
    return transactions.filter(
        (t) => t.transaction_date >= dateFrom && t.transaction_date <= dateTo
    );
}

export function computeAvailableMonths(transactions: DateFilterTransaction[]): string[] {
    const months = new Set<string>();
    for (const t of transactions) {
        months.add(t.transactionDate.slice(0, 7));
    }
    return Array.from(months).sort();
}

export function computeCategoryBreakdown(
    transactions: BreakdownTransaction[],
    type: CashFlowType
): CategoryBreakdown[] {
    const filtered = transactions.filter((t) => t.type === type);

    if (filtered.length === 0) return [];

    const grandTotal = filtered.reduce((sum, t) => sum + t.amount, 0);

    // Group by category_id
    const categoryMap = new Map<string, { name: string; transactions: BreakdownTransaction[] }>();
    for (const t of filtered) {
        if (!categoryMap.has(t.categoryId)) {
            categoryMap.set(t.categoryId, { name: t.categoryName, transactions: [] });
        }
        categoryMap.get(t.categoryId)!.transactions.push(t);
    }

    const result: CategoryBreakdown[] = [];

    for (const [categoryId, { name: categoryName, transactions: catTxns }] of categoryMap) {
        const categoryTotal = catTxns.reduce((sum, t) => sum + t.amount, 0);
        const categoryPercentage = (categoryTotal / grandTotal) * 100;

        // Group subcategories (skip null sub_category_id)
        const subMap = new Map<string, { name: string; total: number; currency: string }>();
        for (const t of catTxns) {
            if (t.subCategoryId === null) continue;
            if (!subMap.has(t.subCategoryId)) {
                subMap.set(t.subCategoryId, { name: t.subCategoryName ?? '', total: 0, currency: t.currency });
            }
            subMap.get(t.subCategoryId)!.total += t.amount;
        }

        const subCategories: SubCategoryBreakdown[] = [];
        for (const [subCategoryId, { name: subCategoryName, total: subTotal, currency }] of subMap) {
            subCategories.push({
                subCategoryId,
                subCategoryName,
                total: subTotal,
                currency,
                percentage: (subTotal / categoryTotal) * 100,
            });
        }

        result.push({
            categoryId,
            categoryName,
            subCategoryId: null,
            subCategoryName: null,
            total: categoryTotal,
            percentage: categoryPercentage,
            subCategories,
        });
    }

    return result;
}
